import { useState } from "react";
import DialogFormPanel from "../../../../../shared/components/panel/DialogFormPanel";
import CreateButtonTrigger from "../../../../../shared/components/button/CreateButtonTrigger";
import AddRoleToUserForm from "./AddRoleToUserForm";

const AddRoleToUserDialog = ({ onSubmitHandler, roles }) => {
  const [isOpen, setIsOpen] = useState(false);

  const onSubmit = (formValues) => {
    onSubmitHandler(formValues);
    setIsOpen(false);
  };

  return (
    <DialogFormPanel
      trigger={<CreateButtonTrigger />}
      title="Añadir rol"
      description="Añade un nuevo rol al usuario"
      content={<AddRoleToUserForm onSubmitHandler={onSubmit} roles={roles} />}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};

export default AddRoleToUserDialog;
